import { Inject, Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AuthService } from '@modules/auth';
import { AuthModel } from '@modules/auth/models/auth.model';
import { environment } from '@environments/environment';
import { SESSION_STORAGE } from '../_tokens';
import { ApiHotelService } from '@donstudio/shared/services/api-hotel.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);
  private readonly apiHotelService = inject(ApiHotelService);
  private authSessionStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  private AUTH_HEADER = 'Authorization';
  protected readonly toastR = inject(ToastrService);

  constructor(@Inject(SESSION_STORAGE) private sessionStorage: Storage) { }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle and log the error here
        this.apiHotelService.isPdfRequest = false;
        if (error.status === 401) {
          return this.authService.refreshToken().pipe(
            switchMap(() => {
              const token = this.getAuthFromSessionStorage()?.authToken;
              const sec = this.getAuthFromSessionStorage()?.sec!;
              const modified = request.clone({
                headers: request.headers.set(this.AUTH_HEADER, 'Bearer ' + token).set('x-Sec', sec)
              });
              return next.handle(modified);
            })
          )
        }
        switch (error.status) {
          case 403:
            this.toastR.error('حساب شما مجوز دسترسی به این بخش را ندارد!', 'عدم دسترسی', { closeButton: true, positionClass: 'toast-bottom-left', timeOut: 5000 })
            break;
          default:
            break;
        }
        // Optionally rethrow the error to propagate it
        return throwError(error);
      })
    );
  }

  private getAuthFromSessionStorage(): AuthModel | undefined {
    try {
      const lsValue = this.sessionStorage.getItem(this.authSessionStorageToken);
      if (!lsValue) {
        return undefined;
      }

      const authData = JSON.parse(lsValue);
      return authData;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }
}